import request from '@/utils/http';
import { otpBaseUrl } from './baseUrl';

// 订单列表
export const getCostOrderInfos = (data) => {
    return request({
        url: `${otpBaseUrl}/tplCostOrderInfos`,
        method: 'post',
        data
    });
};

// 保存订单
export const saveTplCostOrderInfo = (data) => {
    return request({
        url: `${otpBaseUrl}/tplCostOrderInfo/${data.id}`,
        method: 'put',
        data
    });
};

// 保存纯计费订单
export const getOrderDetailInfo = (params) => {
    return request({
        url: `${otpBaseUrl}/tplCostOrderInfoDetails`,
        method: 'get',
        params
    });
};

// 订单操作日志
export const getLog = (params) => {
    return request({
        url: `/api-otp/orderLogs`,
        method: 'get',
        params
    });
};

// 订单路由
export const resInfos = (params) => {
    return request({
        url: `/api-otp/orderTraces`,
        method: 'get',
        params
    });
};

// TODO
// 审核
export const verifyOrder = (data) => {
    return request({
        url: `${otpBaseUrl}/cost/verify`,
        method: 'put',
        data
    });
};

// 取消审核
export const cancelVerifyOrder = (data) => {
    return request({
        url: `${otpBaseUrl}/cost/batchCancelFlow`,
        method: 'post',
        data
    });
};

// 推送
export const pushOrderInfo = (data) => {
    return request({
        url: `${otpBaseUrl}/tplCostOrderInfo/pushBms`,
        method: 'post',
        data
    });
};

// 取消推送
export const cancelPushOrderInfo = (data) => {
    return request({
        url: `${otpBaseUrl}/costOrderInfo/cancelBms`,
        method: 'post',
        data
    });
};
